export const POST_REGISTER = "POST_REGISTER";
export const CHECK_USERNAME = "CHECK_USERNAME";
export const CHECK_REFERRAL_REGION = "CHECK_REFERRAL_REGION";
export const CHECK_IP_REGION = "CHECK_IP_REGION";